module.exports = __webpack_public_path__ + "static/media/game_cover_wd@768.3ac67e95.png";